import {Mapper} from '@s-ui/domain'

const getBreadcrumb = ({text, url} = {}) => ({
  label: text,
  ...(Boolean(url) && {url})
})

export class FromRawBreadcrumbResponseToDetailBreadcrumbVOMapper extends Mapper {
  constructor({config, breadcrumbValueObject}) {
    super()

    this._config = config
    this._valueObject = breadcrumbValueObject
  }

  map = ({section: category1 = {}, section2: category2 = {}, make = {}, model = {}, province = {}, version = {}}) => {
    const breadcrumbs = [
      category1.text && getBreadcrumb(category1),
      category2.text && getBreadcrumb(category2),
      make.text && getBreadcrumb(make),
      model.text && getBreadcrumb(model),
      province.text && getBreadcrumb(province),
      // Version breadcrumb does not need url
      version.text && getBreadcrumb({text: version.text})
    ].filter(Boolean)

    return this._valueObject({breadcrumbs})
  }
}
